export enum PaidStatus {
  Paid = 1, // booking (old system status: Plaćeno = 1)
  PartiallyPaid = 2, // booking (old system status: Plaćen deo = 2)
  NotPaid = 3, // booking (old system status: Nije plaćeno = 3)
}
